import { useEffect, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import api from "./api";
import { registraJob } from "./aiUpload";

/**
 * Se l'URL contiene ?riapri=<jobId> (dallo storico "Letture AI"), scarica il file originale conservato,
 * lo registra sul job (così la lettura non viene ripagata) e lo consegna alla pagina come File.
 */
export function useRiapriAI(tipo, onFile) {
  const [sp] = useSearchParams();
  const navigate = useNavigate();
  const fatto = useRef("");
  const jid = sp.get("riapri");
  useEffect(() => {
    if (!jid || fatto.current === jid) return;
    fatto.current = jid;
    (async () => {
      try {
        const { data: job } = await api.get(`/ai/jobs/${jid}`, { cache: false });
        if (tipo && job.tipo !== `file:${tipo}`) return;
        const { data: blob } = await api.get(`/ai/uploads/${jid}/file`, { responseType: "blob", cache: false });
        const file = new File([blob], job.file || "documento.pdf", { type: blob.type || "application/pdf" });
        registraJob(file, jid);
        onFile(file, job);
      } catch (e) {
        toast.error(e.response?.data?.detail || "Impossibile riaprire la lettura: ricarica il file");
      } finally {
        const next = new URLSearchParams(sp); next.delete("riapri");
        navigate({ search: next.toString() ? `?${next}` : "" }, { replace: true });
      }
    })();
  }, [jid]); // eslint-disable-line react-hooks/exhaustive-deps
}
